import { BASE_API_URL } from "@/recourses/constants";

export const URLs = {
  waitingList: `${BASE_API_URL}api/v1/waiting-list/`,
};
